import { render, staticRenderFns } from "./NewProfiles.vue?vue&type=template&id=8561c324"
import script from "./NewProfiles.vue?vue&type=script&lang=js"
export * from "./NewProfiles.vue?vue&type=script&lang=js"
import style0 from "./NewProfiles.vue?vue&type=style&index=0&id=8561c324&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports